
jQuery(document).ready(function() {
    jQuery('.hover-effect').each(function(index) {
        jQuery(this).removeClass('hover-effect');
        jQuery(this).parent().removeClass('clicked');
        
    });

    jQuery(document).on('click', '.has-hover-desc', function(e) {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {   
            if(jQuery(this).hasClass('clicked')) {
                jQuery(this).removeClass('clicked');
            } else {
                e.preventDefault();
                jQuery('.hover-effect').each(function(index) {
                    jQuery(this).removeClass('hover-effect');
                    jQuery(this).parent().removeClass('clicked');
                    
                });

                jQuery(this).addClass('clicked');
                let eleObj = jQuery(jQuery(this).find('.cwi-card-inner'));
                //console.log(eleObj);
                eleObj.addClass('hover-effect');

            }
        }
    });
});